// extracted by mini-css-extract-plugin
export default {"container":"HeroContent_container__KHsNM","header":"HeroContent_header__vR1sF"};